<template>
	<div class="d-flex gap-2 align-center" :class="titleFirst ? 'justify-space-between' : ''">
		<p v-if="title && titleFirst" class="text-body-m">{{ title }}</p>
		<div
			class="toggle-button align-self-center"
			:class="{ active: modelValue }"
			@click="toggle"
			data-testid="toggle"
		>
			<div :class="['toggle-switch', { active: modelValue }]"></div>
		</div>
		<p v-if="title && !titleFirst" class="text-neutral-700 text-body-m">{{ title }}</p>
	</div>
</template>

<script setup lang="ts">
	interface Props {
		modelValue: boolean
		title?: string
		titleFirst?: boolean
	}
	const props = defineProps<Props>()
	const emit = defineEmits(['update:modelValue'])

	const toggle = () => {
		emit('update:modelValue', !props.modelValue)
	}
</script>

<style scoped lang="scss">
	.toggle-button {
		width: 36px;
		height: 20px;
		background: var(--color-neutral-200);
		border-radius: 20px;
		cursor: pointer;
		position: relative;
		&.active {
			background: var(--color-primary-200);
			.toggle-switch {
				left: 16px;
			}
		}
		.toggle-switch {
			width: 20px;
			height: 20px;
			left: 0;
			background-color: #fff;
			border-radius: 50%;
			position: absolute;
			transition: 0.2s;
		}
	}
</style>
